import {OrderStatus} from '../types';

export default {
  preparing: '#e1b805',
  ready_to_pickup: '#ffa520',
  ready_to_delivery: '#ff7420',
  delivering: '#003d20',
  finished: '#08bf64',
  canceled: '#ff3131',
  me: '#0096c7',
  available: '#ff7420',
  arrival: '#027a3f',
} as unknown as Record<keyof typeof OrderStatus, string>;
